import { render, staticRenderFns } from "./image-feed.vue?vue&type=template&id=31af5863&scoped=true&"
import script from "./image-feed.vue?vue&type=script&lang=js&"
export * from "./image-feed.vue?vue&type=script&lang=js&"
import style0 from "./image-feed.vue?vue&type=style&index=0&id=31af5863&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31af5863",
  null
  
)

export default component.exports